import React, { useEffect, useState } from "react";
import { Alert, AlertIcon, Box, Button, Center, Flex, Heading, HStack, IconButton, Input, InputGroup, InputLeftAddon, InputRightElement, Spinner, Stack, Text, Tooltip, useToast } from "@chakra-ui/react";
import { useAddMonitoringProductsMutation, useDeleteMonitoringProductMutation, useGetMonitoringProductsMutation, useGetProductByIdMutation, useGetProductsMutation } from "../../store/api";
import CustomTable from "../components/custom-table";
import { AddIcon, CloseIcon, InfoIcon, MinusIcon, SearchIcon, ViewIcon } from "@chakra-ui/icons";
import ProductModal from "../components/product-modal";
import { useTable, useFilters, useGlobalFilter, useAsyncDebounce } from 'react-table'
import { debounce } from "rxjs";
import { useNavigate } from "react-router-dom";



const ProductList = (props: any) => {


    const initialArray: any = [];
    const initialSearch: string = '';
    const navigate = useNavigate();
    const toast = useToast();
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [products, setProducts] = useState(initialArray);
    const [count, setCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [productId, setProductId] = useState(0);
    let [monitoredProduct, setMonitoredProduct] = useState(initialArray);
    const [addedEan, setAddedEan] = useState(initialArray);
    const [deleteEan, setDeleteEan] = useState(0);

    const [getMonitoringProducts, { data: eans }] =
        useGetMonitoringProductsMutation();
    const [getProducts, { data: product, isLoading, error, isError, isSuccess }] =
        useGetProductsMutation();
    const [addMonitoringProducts, { data: addedEans,
        isLoading: eanAddLoading,
        error: eanAddError,
        isError: eanAddIsError,
        isSuccess: eanAddIsSuccess }] =
        useAddMonitoringProductsMutation();

    const [deleteMonitoringProduct, { data: deletedEans,
        isLoading: eanDeletedLoading,
        error: eanDeletedError,
        isError: eanDeletedIsError,
        isSuccess: eanDeletedIsSuccess }] =
        useDeleteMonitoringProductMutation();

    const [searchValue, setSearchValue] = useState(initialSearch)
    const [searchEan, setSearchEan] = useState(initialSearch)
    const onChangeSearch = useAsyncDebounce(event => {
        if (event.key === 'Enter' && searchValue?.trim()) {
            searchProducts();
        } else if (event.key === 'Enter' && !searchValue?.trim()) {
            clearSearch(searchEan);
        }
    }, 500)



    const onChangeEan = useAsyncDebounce(event => {
        if (event.key === 'Enter' && searchEan?.trim()) {
            searchProducts();
        } else if (event.key === 'Enter' && !searchEan?.trim()) {
            clearEan(searchValue);
        }
    }, 500)


    const tableColumn = [
        {
            Header: "ID",
            accessor: "id"
        },
        {
            Header: "Name",
            accessor: "name"
        },
        {
            Header: "Brand",
            accessor: "brand"
        },
        {
            Header: "EAN'S",
            accessor: "eans",
            Cell: (props: any) => {
                return (
                    <Box>
                        {props.value.map((ean: never) => (

                            <HStack spacing='10px' key={ean}>
                                <Text fontSize={'small'} >{ean}</Text>
                            </HStack>

                        ))}
                    </Box>
                );
            },
        },
        {
            Header: "Lowest Price",
            accessor: "lowest_price",
            isNumeric: true,
        },
        {
            Header: "Actions",
            accessor: "actions",
            Cell: (props: any) => {
                const item = props.row.original;
                return (

                    <Box>
                        <HStack spacing='10px' key={item.id}>
                            <Tooltip label="View Details">
                                <IconButton
                                    aria-label=''
                                    onClick={() => {
                                        setShowModal(true)
                                        setProductId(item.id)
                                    }}
                                    icon={<ViewIcon h={3} w={3} />}
                                    mr={4}
                                    size={'sm'}
                                    color={ monitoredProduct?.includes(item?.id) ? 'yellow.500' :  'blue.500'}
                                />
                            </Tooltip>

                            {!monitoredProduct?.includes(item?.id) &&
                                <Tooltip label="Add To Watch">
                                    <IconButton
                                        aria-label=''
                                        onClick={() => {
                                            addEanToMonitor(item?.id);
                                        }}
                                        icon={<AddIcon h={2} w={2} />}
                                        mr={2}
                                        size={'sm'}
                                        disabled={monitoredProduct?.length === 5}
                                    />
                                </Tooltip>
                            }
                            {monitoredProduct?.includes(item?.id) &&
                                <Tooltip label="Delete From Watch">
                                    <IconButton
                                        aria-label=''
                                        onClick={() => {
                                            deleteEanFromMonitor(item.id);
                                        }}
                                        icon={<MinusIcon h={2} w={2} />}
                                        mr={2}
                                        size={'sm'}
                                        color={'red.500'}
                                        disabled={eanAddLoading}
                                    />
                                </Tooltip>
                            }
                        </HStack>


                    </Box>
                );
            },
        },
    ]
    const columns = React.useMemo(() => tableColumn, [monitoredProduct]);


    const retrieveProducts = () => {
        getProducts({ page, search: searchValue || null, ean: searchEan || null }).unwrap().then(res => {
            setProducts(res.results);
            setCount(res.count);
            if (res.results?.length) {
                retrieveMonitoringProducts();
            }
        }, error => {
            console.log('error: ', error);
            setProducts([]);
        })
    };

    const searchProducts = () => {
        getProducts({ page, search: searchValue?.trim(), ean: searchEan?.trim() }).unwrap().then(res => {
            setProducts(res.results);
            setCount(res.count);
        }, error => {
            console.log('error: ', error);
            setProducts([]);
        })
    };

    const clearEan = (search: string) => {
        resetSearches(search);
    };

    const clearSearch = (ean: string) => {
        resetSearches('', ean);
    };

    const resetSearches = (search: string = '', ean: string = '') => {
        getProducts({ page, search, ean }).unwrap().then(res => {
            setProducts(res.results);
            setCount(res.count);
        }, error => {
            console.log('error: ', error);
            setProducts([]);
        })
    }

    const retrieveMonitoringProducts = () => {
        getMonitoringProducts('').unwrap().then(res => {
            setMonitoredProduct([...res.ids]);
        }, error => {
            console.log('error: ', error);
        });
    };


    const addEanToMonitor = (id: number) => {
        const ids: number[] = [];
        ids.push(id);
        addMonitoringProducts({ ids }).unwrap().then((res) => {
            setAddedEan([...ids]);
            toast({
                title: "Successfully Added product to watch",
                status: "success",
                duration: 3000,
            });
        }).catch((error) => {
            toast({
                title: error?.data?.message || "Failed to add product to watch",
                status: "error",
                duration: 3000,
            });
        })
    };

    const deleteEanFromMonitor = (id: number) => {
        deleteMonitoringProduct(id).unwrap().then((res) => {
            setDeleteEan(id);
            toast({
                title: "Successfully Remove product to watch",
                status: "info",
                duration: 3000,
            });
        }).catch((error) => {
            toast({
                title: error?.data?.message || "Failed to remove product to watch",
                status: "error",
                duration: 3000,
            });
        })
    };




    useEffect(() => {
        if (!searchEan && !searchValue) {
            retrieveProducts();
        }
    }, [page]);
    useEffect(() => {
        if (addedEan?.length) {
            setMonitoredProduct([...monitoredProduct, ...addedEan]);
        }
    }, [addedEan]);

    useEffect(() => {
        let ids = monitoredProduct.filter((e: number) => e !== deleteEan);
        setMonitoredProduct([...ids]);
    }, [deleteEan]);

    const items = React.useMemo(() => products, [products]);

    if (isLoading) {
        return (
            <Box textAlign="center" py={10} px={10}>
                <Center>
                    <Spinner
                        direction='row' spacing={4}
                        thickness='8px'
                        speed='0.5s'
                        emptyColor='green.200'
                        color='blue.500'
                        size='xl'
                        label='Loading...'
                    />
                </Center>
            </Box>
        );
    }

    if (isError && error) {
        return (
            <Box textAlign="center" py={10} px={10}>
                <Box display="inline-block">
                    <Flex
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        bg={'red.500'}
                        rounded={'50px'}
                        w={'55px'}
                        h={'55px'}
                        textAlign="center">
                        <CloseIcon boxSize={'20px'} color={'white'} />
                    </Flex>
                </Box>
                <Text fontSize="18px" color={'red.500'} mt={3} mb={2}>
                    Error Occurred
                </Text>
                <Text color={'red.500'} fontSize="16px" mb={6}>
                    {(error as any)?.data?.message}
                </Text>
                <Button
                    colorScheme="teal"
                    bgGradient="linear(to-r, teal.400, teal.500, teal.600)"
                    color="white"
                    variant="solid"
                    onClick={() => {
                        if (page > 1) {
                            setPage(1)
                        } else {
                            setSearchEan('');
                            setSearchValue('');
                            resetSearches();
                        }
                    }}
                >
                    Back To First Page
                </Button>
            </Box>
        );
    }

    if (!isLoading && !isError && !products.length) {
        return (
            <Box textAlign="center" py={10} px={10}>
                <InfoIcon boxSize={'50px'} color={'blue.500'} />
                <Text fontSize="18px" mt={3} mb={2}>
                    Products are not available now
                </Text>

                <Button
                    colorScheme="teal"
                    bgGradient="linear(to-r, teal.400, teal.500, teal.600)"
                    color="white"
                    variant="solid"
                    onClick={() => {
                        if (page > 1) {
                            setPage(1)
                        } else {
                            setSearchEan('');
                            setSearchValue('');
                            resetSearches();
                        }
                    }}
                >
                    Back To First Page
                </Button>
            </Box>
        );
    }



    return (
        <>
            <Box textAlign="center" py={10} px={10}>
                <Stack spacing={4}>
                    <HStack>
                        <InputGroup size={'sm'}>
                            <InputLeftAddon children={<SearchIcon color='gray.300' />} />
                            <Input type='text'
                                placeholder='Search by Name,Brand'
                                value={searchValue || ""}
                                onChange={e => {
                                    let value = e.target.value.trim() ? e.target.value : "";
                                    setSearchValue(value);
                                }}
                                onKeyPress={onChangeSearch} />
                            <InputRightElement width='7.3rem'>
                                <HStack spacing='2px' >
                                    <Button h='1.75rem' size='sm' onClick={e => {
                                        if (page === 1) {
                                            searchProducts();
                                        } else {
                                            setPage(1);
                                        }
                                    }} isDisabled={!searchValue}>
                                        {'Search'}
                                    </Button>
                                    {<Button h='1.75rem' size='sm' onClick={e => {
                                        setSearchValue('');
                                        clearSearch(searchEan);
                                    }} isDisabled={!searchValue}>
                                        <CloseIcon></CloseIcon>
                                    </Button>}
                                </HStack>
                            </InputRightElement>
                        </InputGroup>
                        <InputGroup InputGroup size={'sm'}>
                            <InputLeftAddon children={<SearchIcon color='gray.300' />} />
                            <Input type='text'
                                placeholder='Search by EAN'
                                value={searchEan || ""}
                                onChange={e => {
                                    let value = e.target.value.trim() ? e.target.value : "";
                                    setSearchEan(value);
                                }}
                                onKeyPress={onChangeEan}
                            />
                            <InputRightElement width='7.3rem'>
                                <HStack spacing='1px' >
                                    <Button h='1.75rem' size='sm' onClick={e => {
                                        if (page === 1) {
                                            searchProducts();
                                        } else {
                                            setPage(1);
                                        }
                                    }} isDisabled={!searchEan}>
                                        {'Search'}
                                    </Button>
                                    {<Button h='1.75rem' size='sm' onClick={e => {
                                        setSearchEan('');
                                        clearEan(searchValue);
                                    }} isDisabled={!searchEan} >

                                        <CloseIcon></CloseIcon>
                                    </Button>}
                                </HStack>
                            </InputRightElement>
                        </InputGroup>
                    </HStack>
                    <Text fontSize="18px" fontWeight={'bold'} color={'teal'} mt={2} mb={2}>
                        Available Product List
                    </Text>
                    {
                        monitoredProduct?.length === 5 &&
                        <Alert status='error'
                            alignItems='center'
                            justifyContent='center'
                            textAlign='center'>
                            <AlertIcon />
                            You have reached the maximum number(5) of monitored products.
                        </Alert>
                    }

                    <CustomTable
                        columns={columns}
                        data={items}
                        setPage={setPage}
                        setPerPage={setPerPage}
                        currentPage={page}
                        perPage={perPage}
                        totalPage={count} />
                    {showModal && <ProductModal onClose={() => setShowModal(false)} id={productId} />}
                </Stack>
            </Box>

        </>
    );
};

export default ProductList;